import { ThemedIllustration } from './themed-illustration';

const Light = () => (
  <svg width="300" height="240" viewBox="0 0 300 240" fill="none"
       xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <defs>
      <filter id="se-shadow" x="-20%" y="-20%" width="140%" height="140%">
        <feGaussianBlur in="SourceAlpha" stdDeviation="6"/>
        <feOffset dx="0" dy="8" result="o"/>
        <feFlood floodColor="#0F172A" floodOpacity="0.10"/>
        <feComposite in2="o" operator="in"/>
        <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
      </filter>
      <linearGradient id="se-body" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#FFFFFF"/>
        <stop offset="100%" stopColor="#EEF2F7"/>
      </linearGradient>
    </defs>

    {/* Tilted / cracked beaker */}
    <g filter="url(#se-shadow)" transform="translate(72 30) rotate(-18 80 100)">
      {/* beaker body */}
      <path d="M30 8 H130 V20 H120 L120 60
               L150 156 C156 174 144 192 124 192 H36
               C16 192 4 174 10 156 L40 60 V20 H30 Z"
            fill="url(#se-body)"/>
      {/* lightning crack */}
      <path d="M86 30 L72 80 L92 80 L74 138" stroke="#1E3A8A"
            strokeOpacity="0.55" strokeWidth="3" fill="none"
            strokeLinecap="round" strokeLinejoin="round"/>
      {/* liquid level */}
      <path d="M52 110 H108 L142 168 C146 178 140 188 130 188 H30
               C20 188 14 178 18 168 Z"
            fill="#1E3A8A" opacity="0.18"/>
    </g>

    {/* Spilled droplets */}
    <g fill="#1E3A8A" opacity="0.35">
      <ellipse cx="60" cy="208" rx="22" ry="6"/>
      <circle cx="36" cy="200" r="4"/>
      <circle cx="100" cy="216" r="3"/>
      <circle cx="20" cy="186" r="2.5"/>
    </g>

    {/* Lightning bolt accent */}
    <g filter="url(#se-shadow)" transform="translate(220 50)">
      <path d="M22 0 L4 38 L20 38 L8 72 L36 28 L20 28 L30 0 Z"
            fill="url(#se-body)"/>
      <path d="M22 0 L4 38 L20 38 L8 72 L36 28 L20 28 L30 0 Z"
            fill="#1E3A8A" opacity="0.20"/>
    </g>

    <g fill="#1E3A8A" opacity="0.18">
      <circle cx="40" cy="40" r="3"/>
      <circle cx="260" cy="160" r="3"/>
    </g>
  </svg>
);

const Dark = () => (
  <svg width="300" height="240" viewBox="0 0 300 240" fill="none"
       xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <defs>
      <filter id="se-shadow-d" x="-20%" y="-20%" width="140%" height="140%">
        <feGaussianBlur in="SourceAlpha" stdDeviation="6"/>
        <feOffset dx="0" dy="8" result="o"/>
        <feFlood floodColor="#000000" floodOpacity="0.45"/>
        <feComposite in2="o" operator="in"/>
        <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
      </filter>
      <linearGradient id="se-body-d" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#1F2937"/>
        <stop offset="100%" stopColor="#111827"/>
      </linearGradient>
    </defs>
    <g filter="url(#se-shadow-d)" transform="translate(72 30) rotate(-18 80 100)">
      <path d="M30 8 H130 V20 H120 L120 60
               L150 156 C156 174 144 192 124 192 H36
               C16 192 4 174 10 156 L40 60 V20 H30 Z"
            fill="url(#se-body-d)"/>
      <path d="M86 30 L72 80 L92 80 L74 138" stroke="#60A5FA"
            strokeOpacity="0.75" strokeWidth="3" fill="none"
            strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M52 110 H108 L142 168 C146 178 140 188 130 188 H30
               C20 188 14 178 18 168 Z"
            fill="#3B82F6" opacity="0.30"/>
    </g>
    <g fill="#60A5FA" opacity="0.55">
      <ellipse cx="60" cy="208" rx="22" ry="6"/>
      <circle cx="36" cy="200" r="4"/>
      <circle cx="100" cy="216" r="3"/>
      <circle cx="20" cy="186" r="2.5"/>
    </g>
    <g filter="url(#se-shadow-d)" transform="translate(220 50)">
      <path d="M22 0 L4 38 L20 38 L8 72 L36 28 L20 28 L30 0 Z"
            fill="url(#se-body-d)"/>
      <path d="M22 0 L4 38 L20 38 L8 72 L36 28 L20 28 L30 0 Z"
            fill="#60A5FA" opacity="0.35"/>
    </g>
    <g fill="#60A5FA" opacity="0.28">
      <circle cx="40" cy="40" r="3"/>
      <circle cx="260" cy="160" r="3"/>
    </g>
  </svg>
);

export const ServerErrorIllustration = () => (
  <ThemedIllustration light={<Light />} dark={<Dark />} />
);
